import DateFormContainer from '../DatesForm/DateFormContainer';
import ReviewQuote from '../ReviewQuote';
import ProcessingChangeDate from '../ProcessingChangeDate';
import { useChangeDates } from '../ChangeDatesProvider';
import { FC } from 'react';

const ChangeDatesFlow: FC = () => {
  const { stage } = useChangeDates();

  switch (stage) {
    case 'EDIT':
    case 'QUOTING':
      return <DateFormContainer />;
    case 'REVIEW':
      return <ReviewQuote />;
    case 'PROCESSING':
    case 'CONFIRMED':
      return <ProcessingChangeDate />;
    default:
      return null;
  }
};

export default ChangeDatesFlow;
